export enum PostsSort {
  RECENT = 'RECENT',
  OLDEST = 'OLDEST',
  BEST_PICTURE = 'BEST_PICTURE'
}
